<template>
  <!-- TODO PhotoModule w Client -> MediaModule -->
  <div class="photo-wrapper">
    <ContentGeneratorElementsMedia
      :value="content"
      size-image="w2000"
      :aspect-ratio="aspectRatio"
      :aspect-ratio-mobile="aspectRatioMobile"
      :is-no-border-radius="isNoBorderRadius"
    />
  </div>
</template>

<script>
import ContentGeneratorElementsMedia from '../elements/Media.vue'
import { contentFindContent, contentFindOption } from '../../../plugins/content'
export default {
  components: {
    ContentGeneratorElementsMedia
  },
  props: {
    value: { type: Object, default: null }
  },
  computed: {
    content () {
      return contentFindContent(this.value?.content, 'media')
    },
    aspectRatio () {
      return this.value?.options?.find(el => el.key === 'aspectRatio')?.value
    },
    aspectRatioMobile () {
      return this.value?.options?.find(el => el.key === 'aspectRatioMobile')?.value
    },
    isNoBorderRadius () {
      return contentFindOption(this.value.options, 'isNoBorderRadius').value || null
    }
  }
}

</script>

<style lang="scss" scoped>
  // TODO zmienić na media-module
  .photo-wrapper {
    position: relative;
    :deep(.photo-wrapper ) {
      border-radius: var(--border-radius);
    }
  }
</style>
